import styled from 'styled-components';
export const VolumeRocker = styled.div `
    display: inline-block;
    height: 20px;
    width: 100px;
    position: absolute;
    top: -7px;
`;
//# sourceMappingURL=index.js.map